import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { withAnalytic } from '@skooldio/analytics-provider/dist/Analytics/hoc';

import { Icon, ICON_LIST, BackdropProgress } from 'Components/Base';
import ExportIndividualUnitReportData from 'Domains/ExportIndividualUnitReportData';
import ButtonOutlinedIcon from 'Components/ButtonOutlinedIcon';
import { useAnalytics } from 'Libs/Analytics';
import { SYLLABUS_MODE } from 'Domains/syllabus';

const IndividualUnitExporter = ({
  disabled,
  appliedFilter,
  schoolCode,
  classroomUsername,
  onLogAction,
  mode,
}) => {
  const { send } = useAnalytics();
  const { t } = useTranslation('individualUnit');
  const [loading, setLoading] = useState(false);

  const {
    term: { id: schoolTermId } = {},
    grade: { id: schoolGradeId } = {},
    classNo: { classNo } = {},
    subject: { id: subjectId } = {},
    syllabus: { courseCode } = {},
  } = appliedFilter;

  return (
    <ExportIndividualUnitReportData
      schoolTermId={schoolTermId}
      schoolGradeId={schoolGradeId}
      classNo={classNo}
      subjectId={subjectId}
      courseCode={courseCode}
      schoolCode={schoolCode}
      classroomUsername={classroomUsername}
      mode={mode}
    >
      {({ fetchIndividualUnitReportData, exportIndividualUnitReport }) => {
        return (
          <Fragment>
            <BackdropProgress open={loading} />
            <ButtonOutlinedIcon
              textProp={{
                fontWeight: 'semibold',
              }}
              leftIcon={<Icon name={ICON_LIST.EXPORT} />}
              lineHeight={'0.5'}
              height={'40px'}
              message={t('EXPORT')}
              disabled={disabled || loading}
              onClick={async () => {
                onLogAction({
                  category: 'Export',
                  action: `Click`,
                  label: `Click on unit page`,
                });
                send('export', { on: 'individual_unit_page' });
                setLoading(true);
                const { data, error } = await fetchIndividualUnitReportData();
                setLoading(false);
                if (!error) {
                  await exportIndividualUnitReport({
                    report:
                      mode === SYLLABUS_MODE.TRADITIONAL
                        ? data.foIndividualUnitReport
                        : data.foTKIndividualUnitReport,
                    type: 'xlsx',
                  });
                }
              }}
            />
          </Fragment>
        );
      }}
    </ExportIndividualUnitReportData>
  );
};

export default withAnalytic(IndividualUnitExporter);
